import React from 'react';
import './App.css';
import Header from './components/Header';
import Form from './components/Form';
import Info from './components/Info';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Header />
      <Form />
      <Info />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
    </div>
  );
}

export default App;
